import Cookies from 'js-cookie';

const getRequestId = () => {
    return window?.clientData?.baseConfig?.requestId;
};

export function setRequestId(path: string) {
    Cookies.set('REQUEST_ID', JSON.stringify({ id: getRequestId(), pathname: path }), {
        secure: true,
        sameSite: 'strict',
    });
}

export default getRequestId;
